if (!customElements.get('esalon-sticky-cart')) {
  customElements.define(
    'esalon-sticky-cart',
    class EsalonStickyCart extends HTMLElement {
      constructor() {
        super();
        this.observer = null;
        this.variantChangeUnsubscriber = null;
      }

      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.productFormId = this.dataset.productFormId;
        this.button = this.querySelector('[data-add-to-cart-trigger]');
        this.buttonText = this.querySelector('.esalon-sticky-cart__button-text');
        this.priceContainer = this.querySelector('.esalon-sticky-cart__price');

        this.button.addEventListener('click', this.onButtonClick.bind(this));
        this.initObserver();

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange.bind(this));
        }
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
      }

      initObserver() {
        var productInfo = document.getElementById('MainProduct-' + this.sectionId);
        if (!productInfo) return;

        var buyButtons = productInfo.querySelector('.product-form__buttons');
        if (!buyButtons) return;

        var headerHeight =
          parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 65;

        this.observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(
              function (entry) {
                if (entry.isIntersecting) {
                  this.hide();
                } else if (entry.boundingClientRect.top < 0) {
                  this.show();
                } else {
                  this.hide();
                }
              }.bind(this),
            );
          }.bind(this),
          { rootMargin: '-' + headerHeight + 'px 0px 0px 0px', threshold: 0 },
        );

        this.observer.observe(buyButtons);
      }

      show() {
        this.classList.add('esalon-sticky-cart--visible');
        this.setAttribute('aria-hidden', 'false');
      }

      hide() {
        this.classList.remove('esalon-sticky-cart--visible');
        this.setAttribute('aria-hidden', 'true');
      }

      onButtonClick() {
        var form = document.getElementById(this.productFormId);
        if (!form) return;
        if (form.requestSubmit) {
          form.requestSubmit();
        } else {
          form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
          form.submit();
        }
      }

      onVariantChange(event) {
        var data = event.data;
        if (data.sectionId !== this.sectionId) return;

        this.updatePrice(data.html);
        this.updateButton(data.variant);
      }

      updatePrice(html) {
        if (!this.priceContainer || !html) return;

        var priceSource = html.getElementById('price-' + this.sectionId);
        if (!priceSource) return;

        var salePrice = priceSource.querySelector('.price--highlight');
        var comparePrice = priceSource.querySelector('.price--compare s');
        var regularPrice = priceSource.querySelector('.price:not(.price--highlight):not(.price--compare)');

        var frag = document.createDocumentFragment();
        if (salePrice) {
          var saleSpan = document.createElement('span');
          saleSpan.className = 'esalon-sticky-cart__price-sale';
          saleSpan.textContent = salePrice.textContent.trim();
          frag.appendChild(saleSpan);
          if (comparePrice) {
            var cmpSpan = document.createElement('span');
            cmpSpan.className = 'esalon-sticky-cart__price-compare';
            var s = document.createElement('s');
            s.textContent = comparePrice.textContent.trim();
            cmpSpan.appendChild(s);
            frag.appendChild(cmpSpan);
          }
        } else if (regularPrice) {
          var regSpan = document.createElement('span');
          regSpan.className = 'esalon-sticky-cart__price-regular';
          regSpan.textContent = regularPrice.textContent.trim();
          frag.appendChild(regSpan);
        }

        while (this.priceContainer.firstChild) this.priceContainer.removeChild(this.priceContainer.firstChild);
        this.priceContainer.appendChild(frag);
      }

      updateButton(variant) {
        if (!this.button || !this.buttonText) return;

        if (!variant) {
          this.button.disabled = true;
          this.buttonText.textContent = window.variantStrings.unavailable;
        } else if (!variant.available) {
          this.button.disabled = true;
          this.buttonText.textContent = window.variantStrings.soldOut;
        } else {
          this.button.disabled = false;
          this.buttonText.textContent = window.variantStrings.addToCart;
        }
      }
    },
  );
}
